package com.trevorwiebe.timesheet.admin.ownerOperator.data

import com.trevorwiebe.timesheet.admin.ownerOperator.domain.OwnerOperatorRepository
import com.trevorwiebe.timesheet.core.data.FirestoreListenerRegistry
import com.trevorwiebe.timesheet.core.data.Utils.errorWrapper
import com.trevorwiebe.timesheet.core.domain.CoreRepository
import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.core.domain.dto.OwnerOperatorDto
import com.trevorwiebe.timesheet.core.domain.dto.toOwnerOperator
import com.trevorwiebe.timesheet.core.domain.dto.toOwnerOperatorDto
import com.trevorwiebe.timesheet.core.domain.model.OwnerOperator
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class OwnerOperatorRepositoryImpl(
    private val firebaseDatabase: Firebase,
    private val coreRepository: CoreRepository
) : OwnerOperatorRepository {

    override suspend fun getOwnerOperators(): Flow<TSResult> {
        val orgIdResult = coreRepository.getOrganizationId()
        if (orgIdResult.error != null) return kotlinx.coroutines.flow.flow { emit(orgIdResult) }
        val orgId = orgIdResult.data as String

        val flow = firebaseDatabase.firestore
            .collection("organizations")
            .document(orgId)
            .collection("ownerOperators")
            .snapshots
            .map { snapshot ->
                snapshot.documents
                    .map { doc -> doc.data<OwnerOperatorDto>().toOwnerOperator(id = doc.id) }
                    .sortedWith(compareBy({ it.order }, { it.contactName.lowercase() }))
            }
            .map { TSResult(data = it) }

        return FirestoreListenerRegistry.registerFlow(flow)
    }

    override suspend fun addOwnerOperator(ownerOperator: OwnerOperator): TSResult {
        return errorWrapper {
            val orgId = coreRepository.getOrganizationId().data as String
            val result = firebaseDatabase.firestore
                .collection("organizations")
                .document(orgId)
                .collection("ownerOperators")
                .add(ownerOperator.toOwnerOperatorDto())
            TSResult(data = result.id)
        }
    }

    override suspend fun updateOwnerOperator(ownerOperator: OwnerOperator): TSResult {
        return errorWrapper {
            val orgId = coreRepository.getOrganizationId().data as String
            firebaseDatabase.firestore
                .collection("organizations")
                .document(orgId)
                .collection("ownerOperators")
                .document(ownerOperator.id)
                .set(ownerOperator.toOwnerOperatorDto(), merge = true)
            TSResult(data = "Owner operator updated successfully")
        }
    }
}
